import styled from 'styled-components';

import { Button } from '~/components/button/Button';
import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const EntityDetailsRoot = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 16px;
  margin: 16px;
`;

export const LeftImageContainer = styled.div`
  flex: 0 0 40px;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${typographyV2.titleLg}
`;

export const Tag = styled.p`
  ${typographyV2.bodySm}
  color: var(--text-soft);
  text-transform: uppercase;
`;

export const ActionButton = styled(Button)<{ $isActive?: boolean }>`
  justify-self: flex-end;
  color: ${props =>
    props.$isActive ? 'var(--text-success)' : 'var(--text-default)'};
  svg {
    fill: ${props =>
      props.$isActive ? 'var(--icon-success)' : 'var(--icon-default)'};
  }
`;
